/* Salida exprés: explicación, calendario y validación de la variante concreta. */
(function () {
  'use strict';
  var config = window.expressI18n;
  if (!config) return;
  var bound = false, lastFocus = null, refreshing = false;
  var requests = new WeakMap(), cache = new Map();
  function modal() { return document.querySelector('[data-express-modal]'); }
  function close() {
    if (modal()) modal().hidden = true;
    document.body.classList.remove('express-modal-abierto');
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  }
  function initModal() {
    var nodes = Array.from(document.querySelectorAll('[data-express-modal]'));
    if (nodes.length) {
      var latest = nodes[nodes.length - 1];
      nodes.slice(0, -1).forEach(function (node) { node.remove(); });
      if (latest.parentNode !== document.body) document.body.appendChild(latest);
    }
    if (bound) return;
    bound = true;
    document.addEventListener('click', function (event) {
      var open = event.target.closest('[data-express-open]'), current = modal();
      if (!current) return;
      if (open) {
        event.preventDefault(); lastFocus = open; current.hidden = false;
        document.body.classList.add('express-modal-abierto');
        current.querySelector('.express-modal').scrollTop = 0;
        current.querySelector('[data-express-close]').focus({ preventScroll: true });
      } else if (event.target.closest('[data-express-close]') || event.target === current) close();
    });
    document.addEventListener('keydown', function (event) {
      var current = modal();
      if (!current || current.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key !== 'Tab') return;
      var controls = Array.from(current.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex="0"]'));
      var first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || !current.contains(document.activeElement))) {
        event.preventDefault(); if (last) last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !current.contains(document.activeElement))) {
        event.preventDefault(); if (first) first.focus();
      }
    });
  }
  function madrid(epoch) {
    var parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23', weekday: 'short' }).formatToParts(new Date(epoch));
    var result = {};
    parts.forEach(function (part) { result[part.type] = part.value; });
    result.date = result.year + '-' + result.month + '-' + result.day;
    return result;
  }
  function key(epoch) {
    var part = madrid(epoch);
    return part.date + ':' + (Number(part.hour) >= Number(config.cutoff) ? 'after' : 'before');
  }
  var calendar = key(Number(config.generatedAt) * 1000 || Date.now());
  function paint() {
    var now = Math.floor(Date.now() / 1000);
    document.querySelectorAll('[data-express-countdown]').forEach(function (node) {
      var seconds = Number(node.dataset.expressCountdown) - now;
      if (!Number.isFinite(seconds) || seconds <= 0) { node.hidden = true; return; }
      var h = Math.floor(seconds / 3600), m = Math.floor((seconds % 3600) / 60);
      var template = h > 0 ? config.orderWithin : (config.orderWithinMinutes || config.orderWithin);
      node.textContent = (template || '@@T@@').replace('@@T@@', (h > 0 ? h + ' h ' : '') + m + ' min');
      node.hidden = false;
    });
    var part = madrid(Date.now());
    var holiday = (config.holidays || '').split(',').map(function (s) { return s.trim(); }).includes(part.date);
    var row = part.weekday === 'Sat' || part.weekday === 'Sun' || holiday ? 2 : (Number(part.hour) >= Number(config.cutoff) ? 1 : 0);
    document.querySelectorAll('.express-hf').forEach(function (node, i) { node.classList.toggle('is-now', i === row); });
  }
  function stateFor(productUrl) {
    var url = new URL(productUrl, location.origin);
    if (url.origin !== location.origin) return Promise.reject(new Error('different_origin'));
    url.searchParams.set('section_id', 'express-state');
    if (config.country) url.searchParams.set('country', config.country);
    var cacheKey = url.href, old = cache.get(cacheKey);
    if (old && Date.now() - old.time < 5000) return old.promise;
    url.searchParams.set('_', Date.now());
    var promise = fetchHtml(url.href)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), node = doc.querySelector('[data-express-state]');
        if (!node) throw new Error('state_missing');
        var state = JSON.parse(node.textContent);
        if (state.version !== 2 || !state.v || !state.stock || (config.country && state.country !== config.country)) throw new Error('state_mismatch');
        var age = Date.now() / 1000 - Number(state.delivery && state.delivery.generated_at);
        if (!Number.isFinite(age) || age < -60 || age > 300) throw new Error('state_stale');
        return { state: state, doc: doc };
      });
    cache.set(cacheKey, { time: Date.now(), promise: promise });
    promise.catch(function () { cache.delete(cacheKey); });
    return promise;
  }
  function fetchHtml(url) {
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 10000);
    return fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('express_http'); return response.text(); })
      .finally(function () { clearTimeout(timer); });
  }
  function info(root) { return root.closest('product-info') || root.closest('.product') || root.parentNode; }
  function selected(root) {
    var input = info(root).querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : root.dataset.expressVariantId;
  }
  function revalidate(root) {
    if (config.revalidate === false) return Promise.resolve();
    var variant = selected(root), input = info(root).querySelector('[name="quantity"]');
    var quantity = Math.max(1, Number(input && input.value) || 1), token = {};
    requests.set(root, token);
    return stateFor(root.dataset.expressProductUrl).then(function (result) {
      if (!root.isConnected || requests.get(root) !== token || selected(root) !== variant) return;
      if (!Object.prototype.hasOwnProperty.call(result.state.v, variant)) return;
      var eligible = result.state.enabled && result.state.v[variant] === 1 && Number(result.state.stock[variant]) >= quantity;
      root.querySelectorAll('.express-badge').forEach(function (node) { node.hidden = !eligible; });
      info(root).querySelectorAll('.express-salida').forEach(function (node) { node.hidden = !eligible; });
    }).catch(function () { /* Sin red se conserva la última respuesta del servidor. */ });
  }
  function revalidateProducts() { return Promise.all(Array.from(document.querySelectorAll('[data-express-product-url]')).map(revalidate)); }
  function attachCardBadge(container, productUrl, selection) {
    if (selection) {
      container.querySelectorAll('[data-express-recommendation-badge]').forEach(function (node) { node.remove(); });
      var selectedUrl = new URL(productUrl, location.origin);
      selectedUrl.searchParams.set('variant', String(selection.variantId));
      productUrl = selectedUrl.href;
    }
    var token = {}; requests.set(container, token);
    return stateFor(productUrl).then(function (result) {
      if (requests.get(container) !== token) return;
      container.querySelectorAll('[data-express-recommendation-badge]').forEach(function (node) { node.remove(); });
      var eligible = result.state.all === 1;
      if (selection) {
        var variant = String(selection.variantId), quantity = Math.max(1, Number(selection.quantity) || 1);
        eligible = String(result.state.selected_variant_id) === variant && result.state.v[variant] === 1 && Number(result.state.stock[variant]) >= quantity;
      }
      if (!result.state.enabled || !eligible) return;
      var badge = result.doc.querySelector(selection ? '[data-express-variant] .express-linea' : '[data-express-card] .express-cinta');
      if (!badge) return;
      badge = document.importNode(badge, true); badge.className = 'express-linea';
      badge.setAttribute('data-express-recommendation-badge', '');
      (container.querySelector('.cart-upsell-recommendation__info, .cart-drawer-recommendation__info, .cart-upsell-added__product-info') || container).appendChild(badge);
    }).catch(function () { /* Sin confirmación no se añade etiqueta. */ });
  }
  window.expressUI = { attachCardBadge: attachCardBadge, revalidate: revalidateProducts };
  function copy(source, target) {
    if (!source || !target) return;
    target.innerHTML = source.innerHTML;
    Array.from(source.attributes).forEach(function (attr) { if (attr.name.indexOf('data-express-') === 0) target.setAttribute(attr.name, attr.value); });
    target.querySelectorAll('script').forEach(function (old) {
      if (old.type === 'application/json') return;
      var script = document.createElement('script');
      Array.from(old.attributes).forEach(function (attr) { script.setAttribute(attr.name, attr.value); });
      script.textContent = old.textContent; old.replaceWith(script);
    });
  }
  function refreshProduct(root) {
    var section = info(root).dataset.section;
    if (!section) return Promise.resolve();
    var variant = selected(root), url = new URL(root.dataset.expressProductUrl, location.origin);
    url.searchParams.set('section_id', section);
    if (variant) url.searchParams.set('variant', variant);
    if (config.country) url.searchParams.set('country', config.country);
    url.searchParams.set('_', Date.now());
    return fetchHtml(url.href)
      .then(function (html) {
        if (!root.isConnected || selected(root) !== variant) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        ['ExpressBadge-', 'DeliveryEstimate-'].forEach(function (prefix) { copy(doc.getElementById(prefix + section), document.getElementById(prefix + section)); });
      });
  }
  function refreshCalendar() {
    var next = key(Date.now());
    if (next === calendar || refreshing || document.hidden || document.querySelector('.cart-item--disabled, product-form .loading, cart-items .loading')) return;
    refreshing = true;
    // Una fecha caducada deja de mostrarse mientras llega la nueva respuesta.
    document.querySelectorAll('.express-salida, [data-delivery-generated-at], .express-carrito').forEach(function (node) { node.hidden = true; });
    Promise.all(Array.from(document.querySelectorAll('[data-express-product-url]')).map(refreshProduct))
      .then(function () {
        return Promise.all(Array.from(document.querySelectorAll('cart-items, cart-drawer-items')).map(function (cart) {
          return typeof cart.onCartUpdate === 'function' ? cart.onCartUpdate() : Promise.resolve();
        }));
      }).then(function () {
        var stale = Array.from(document.querySelectorAll('[data-express-generated-at], [data-delivery-generated-at]')).some(function (node) { return key(Number(node.dataset.expressGeneratedAt || node.dataset.deliveryGeneratedAt) * 1000) !== next; });
        if (stale) throw new Error('calendar_stale');
        calendar = next; cache.clear(); paint(); return revalidateProducts();
      }).catch(function () { /* Reintentar en el siguiente ciclo. */ }).finally(function () { refreshing = false; });
  }
  function changed() { paint(); cache.clear(); revalidateProducts(); }
  function init() {
    initModal(); paint(); revalidateProducts(); refreshCalendar();
    document.querySelectorAll('[data-express-recommendation-url]').forEach(function (card) { attachCardBadge(card, card.dataset.expressRecommendationUrl); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  setInterval(function () { paint(); refreshCalendar(); }, 30000);
  document.addEventListener('variant:change', changed);
  document.addEventListener('cart:refresh', changed);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('change', function (event) { if (event.target.matches('[name="quantity"]')) changed(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) { changed(); refreshCalendar(); } });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, changed);
})();
